import template from './qna.chat.tpl.html';
import controller from './qna.chat.controller.js';

export const qnachat = {
    bindings: {
        nickname: '<',
        descriptiveText: '<',
        signalNewAnswer: '&'
    },
    template,
    controller
};
